import Vue from 'vue';

import productdataApi from '../../components/services/api/productdataAPI.js'
//import globalsApi from '../../components/services/api/globals.js'

// local state
// local state
const getDefaultState = () => {
    return {
        product_data: [{
           /*  description_short: '',
            description_long: '',
            price: '',
            delivery: '',
            quantity: 0,
            product_media: [],
            accessories: [], */


        }],
        /* techproperties label will be replaced with table_fields_techproperties label
        techproperties: [
            { key: 'ref_no', label: 'lang.global.product.tabs.techdata.refno', unit: '' },
            { key: 'version', label: 'lang.global.product.tabs.techdata.version', unit: '' },
            { key: 'type', label: 'lang.global.product.tabs.techdata.type', unit: '' },
            { key: 'max_angle', label: 'global.product.tabs.techdata.max_angle', sort: 4 },
            { key: 'voltage', label: 'lang.global.product.tabs.techdata.voltage', unit: 'lang.units.volt' },
            { key: 'max_rpm', label: 'lang.global.product.tabs.techdata.rpm', unit: 'lang.units.rpm' },
            { key: 'speedcontrol_type', label: 'lang.speedcontrol_type', unit: '' },
            { key: 'lining', label: 'lang.lining', unit: '' },
            { key: 'explosionproof', label: 'lang.explosionproof', unit: '' },
            { key: 'tempclass', label: 'lang.tempclass', unit: '' },
            { key: 'flc_uncontrolled1', label: 'lang.global.product.tabs.techdata.flc_uncontrolled', unit: 'lang.units.amper' },
            { key: 'flc_uncontrolled2', label: 'lang.global.product.tabs.techdata.flc_uncontrolled', unit: 'lang.units.amper' },
            { key: 'power1', label: 'lang.global.product.tabs.techdata.power', unit: 'lang.units.watt' },
            { key: 'power2', label: 'lang.global.product.tabs.techdata.power', unit: 'lang.units.watt' },
            { key: 'protectionclass', label: 'lang.global.product.tabs.techdata.protectionclass', unit: '' },
            { key: 'temp_controlled', label: 'lang.global.product.tabs.techdata.protectionclass', unit: 'lang.units.degree' },
            { key: 'temp_uncontrolled', label: 'lang.global.product.tabs.techdata.temp_max', unit: 'lang.units.degree' },
            { key: 'temp_controlled', label: 'lang.global.product.tabs.techdata.temp_max', unit: 'lang.units.degree' },
            { key: 'connect_diameter', label: 'lang.connect_diameter', unit: 'lang.units.mm' },
            { key: 'duct_dimension', label: 'lang.duct_dimension', unit: 'lang.units.mm' },
            { key: 'ec_technology', label: 'lang.ec_technology', unit: '' },
            { key: 'hotair_upto120', label: 'lang.hotair_upto120', unit: '' },
            { key: 'weight', label: 'lang.global.product.tabs.techdata.weight', unit: 'lang.units.kilo' },
            { key: 'delivery', label: 'lang.global.product.tabs.techdata.delivery', unit: 'lang.units.week_short' }

        ],
      */
        table_fields_techproperties: [
            { key: 'ref_no', label: 'lang.global.product.tabs.techdata.refno', sort: 1, unit: '' },
            { key: 'version', label: 'lang.global.product.tabs.techdata.version', sort: 2, unit: '' },
            { key: 'type', label: 'lang.global.product.tabs.techdata.type', sort: 3, unit: '' },
            { key: 'max_angle', label: 'lang.global.product.tabs.techdata.max_angle', sort: 4, unit: 'lang.units.degree_short' },
            { key: 'max_volumeflow', label: 'lang.global.product.tabs.techdata.max_volumeflow', sort: 5, unit: 'lang.units.airflow_volume' },
            /* { key: 'max_pressure', label: 'lang.global.product.tabs.techdata.max_pressure', sort: 6, unit: 'lang.units.pascal' },*/
            { key: 'op_volumeflow', label: 'lang.global.product.tabs.techdata.volumeflow.op', sort: 5, unit: 'lang.units.airflow_volume' },
            { key: 'op_pressure', label: 'lang.global.product.tabs.techdata.pressure.op', sort: 5, unit: 'lang.units.pascal' },
            { key: 'op_angle', label: 'lang.global.product.tabs.techdata.angle.op', sort: 5,  unit: 'lang.units.degree_short' },

            { key: 'max_dba', label: 'lang.global.product.tabs.techdata.max_dba', sort: 7, unit: 'lang.units.dba' },
            { key: 'speedcontrol_type', label: 'lang.speedcontrol_type', sort: 10, unit: '' },
         /*    { key: 'max_rpm', label: 'lang.global.product.tabs.techdata.max_rpm', sort: 11, unit: 'lang.units.rpm' }, */
            { key: 'rpm1', label: 'lang.global.product.tabs.techdata.rpm1', sort: 12, unit: 'lang.units.rpm' },
            { key: 'rpm2', label: 'lang.global.product.tabs.techdata.rpm2', sort: 13, unit: 'lang.units.rpm' },
          /*   { key: 'rpm', label: 'lang.global.product.tabs.techdata.rpm', sort: 13, unit: 'lang.units.rpm' }, */
            { key: 'ppz1', label: 'lang.global.product.tabs.techdata.ppz1', sort: 20, unit: '' },
            { key: 'ppz2', label: 'lang.global.product.tabs.techdata.ppz2', sort: 21, unit: '' },
           /*  { key: 'ppz', label: 'lang.global.product.tabs.techdata.ppz', sort: 21, unit: '' }, */
            { key: 'voltage', label: 'lang.global.product.tabs.techdata.voltage', sort: 22, unit: 'lang.units.volt' },
            { key: 'voltage1', label: 'lang.global.product.tabs.techdata.voltage1', sort: 23, unit: 'lang.units.volt' },
            { key: 'voltage2', label: 'lang.global.product.tabs.techdata.voltage2', sort: 24, unit: 'lang.units.volt' },
            { key: 'frequency1', label: 'lang.global.product.tabs.techdata.frequency1', sort: 25, unit: 'lang.units.hz' },
            { key: 'frequency2', label: 'lang.global.product.tabs.techdata.frequency2', sort: 26, unit: 'lang.units.hz' },
            { key: 'phase', label: 'lang.global.product.tabs.techdata.phase', sort: 27, unit: 'lang.units.ph' },
            { key: 'flc_uncontrolled1', label: 'lang.global.product.tabs.techdata.flc_uncontrolled1', sort: 28, unit: 'lang.units.amper' },
            { key: 'flc_uncontrolled2', label: 'lang.global.product.tabs.techdata.flc_uncontrolled2', sort: 29, unit: 'lang.units.amper' },
            /* { key: 'flc_uncontrolled', label: 'lang.global.product.tabs.techdata.flc_uncontrolled', sort: 29, unit: 'lang.units.amper' }, */
            { key: 'stc_uncontrolled', label: 'lang.global.product.tabs.techdata.stc_uncontrolled', sort: 30, unit: 'lang.units.amper' },
            { key: 'power1', label: 'lang.global.product.tabs.techdata.power1', sort: 31, unit: 'lang.units.watt'  },
            { key: 'power2', label: 'lang.global.product.tabs.techdata.power2', sort: 32, unit: 'lang.units.watt' },
           /*  { key: 'power', label: 'lang.global.product.tabs.techdata.power', sort: 32, unit: 'lang.units.watt' }, */
            { key: 'temp', label: 'lang.global.product.tabs.techdata.temp', sort: 40, unit: 'lang.units.degree' },
            { key: 'temp_controlled', label: 'lang.global.product.tabs.techdata.temp_controlled', sort: 41, unit: 'lang.units.degree' },
            { key: 'temp_uncontrolled', label: 'lang.global.product.tabs.techdata.temp_uncontrolled', sort: 42, unit: 'lang.units.degree' },
            { key: 'tempclass', label: 'lang.tempclass', sort: 43, unit: '' },
            { key: 'ec_technology', label: 'lang.ec_technology', sort: 50, unit: '' },
            { key: 'lining', label: 'lang.lining', sort: 51, unit: '' },
            { key: 'explosionproof', label: 'lang.explosionproof', sort: 52, unit: '' },
            { key: 'protectionclass', label: 'lang.global.product.tabs.techdata.protectionclass', sort: 53, unit: '' },
            { key: 'isoclass', label: 'lang.global.product.tabs.techdata.isoclass', sort: 54, unit: '' },
            { key: 'hotair_upto120', label: 'lang.hotair_upto120', sort: 55, unit: '' },
            { key: 'connect_diameter', label: 'lang.connect_diameter', sort: 60, unit: 'lang.units.mm' },
            { key: 'duct_dimension', label: 'lang.duct_dimension', sort: 61, unit: 'lang.units.mm' },
            { key: 'weight', label: 'lang.global.product.tabs.techdata.weight', sort: 62, unit: 'lang.units.kilo' },
            { key: 'weight_venti', label: 'lang.global.product.tabs.techdata.weight_venti', sort: 63, unit: 'lang.units.kilo' },
            { key: 'device_execution', label: 'lang.global.product.tabs.techdata.device_execution', sort: 70, unit: '' },
            { key: 'assembly_position', label: 'lang.global.product.tabs.techdata.assembly_position', sort: 71, unit: '' },
            { key: 'heat_exchanger_type', label: 'lang.global.product.tabs.techdata.heat_exchanger_type', sort: 72, unit: '' },
            { key: 'thrust', label: 'lang.global.product.tabs.techdata.thrust', sort: 73, unit: '' },
            { key: 'erp_sec_class_middle', label: 'lang.global.product.tabs.techdata.erp_sec_class_middle', sort: 80, unit: '' },
            { key: 'erp_vmax', label: 'lang.global.product.tabs.techdata.erp_vmax', sort: 81, unit: 'lang.units.airflow_volume' },
            { key: 'erp_vref', label: 'lang.global.product.tabs.techdata.erp_vref', sort: 82, unit: 'lang.units.cubic_meter_per_second' },
            { key: 'erp_etat', label: 'lang.global.product.tabs.techdata.erp_etat', sort: 83, unit: 'lang.percent' },
            { key: 'erp_qnom', label: 'lang.global.product.tabs.techdata.erp_qnom', sort: 84, unit: 'lang.units.cubic_meter_per_second' },
           /* { key: 'post_heating_hot_water_config', label: 'lang.global.product.tabs.techdata.post_heating_hot_water_config', sort: 90, unit: '' },*/
            { key: 'ss_nr', label: 'lang.global.product.tabs.techdata.ss_nr', sort: 91, unit: '' },
            { key: 'delivery', label: 'lang.global.product.tabs.techdata.delivery', sort: 92, unit: 'lang.units.week_short' },
        ],







        table_fields: [
            { key: 'image', label: '' },
            { key: 'ref_no', label: 'lang.global.product.tabs.techdata.refno' },
            { key: 'type', label: 'lang.global.product.tabs.techdata.desc_short' },
            /* { key: 'type', label: 'lang.global.product.tabs.techdata.type'},
            { key: 'description_short', label: 'lang.global.product.tabs.techdata.desc_short' },
            { key: 'price', label: 'lang.global.price' }, */
            { key: 'wg', label: 'lang.global.product.tabs.accessories.wg' },
            { key: 'info', label: '' },


        ],
        lvtext: '',
       /*  media_dir: '/mediadata/', */
      /*   mediaData: [], */
        acoustics: [],
        product_media: [],
        accessories:[],
        table_fields_acoustics: [
            { key: 'acoustictyp', label: 'lang.global.product.tabs.techdata.spectrum', sortable: false },
            { key: 'dba', label: 'lang.units.hz', sortable: false },
            { key: 'hz_sum', label: 'lang.global.product.tabs.techdata.acoustic.total', sortable: false },
            { key: 'hz_125', label: '125', sortable: false },
            { key: 'hz_250', label: '250', sortable: false },
            { key: 'hz_500', label: '500', sortable: false },
            { key: 'hz_1000', label: '1k', sortable: false },
            { key: 'hz_2000', label: '2k', sortable: false },
            { key: 'hz_4000', label: '4k', sortable: false },
            { key: 'hz_8000', label: '8k', sortable: false },
        ],
        curves: [],
        chartproperties: [],
        calculatedpoint: [],
        calculatedpoint_polynomial: [],
        table_fields_download: [
            { key: 'media_type', label: 'lang.downloads.tablecolheader.title' },
         /*    { key: 'description', label: 'lang.downloads.tablecolheader.description' }, */
            { key: 'filename', label: 'lang.downloads.tablecolheader.filename' },
           /*  { key: 'filetype', label: 'lang.downloads.tablecolheader.filetyp' },
            { key: 'filesize', label: 'lang.downloads.tablecolheader.filesize' }, */
            { key: 'cloud', label: '' },

        ],
        table_fields_tocart: [
            { key: 'image', label: '' },
            { key: 'ref_no', label: 'lang.global.product.tabs.techdata.refno' },
            { key: 'type', label: 'lang.global.product.tabs.techdata.desc_short' },
             /*{ key: 'type', label: 'lang.global.product.tabs.techdata.type' },
            { key: 'description_short', label: 'lang.global.product.tabs.techdata.desc_short' },
            { key: 'price', label: 'lang.global.price' },*/
            { key: 'wg', label: 'lang.global.product.tabs.accessories.wg' },
            { key: 'quantity', label: 'lang.addtocart.quantity' },
            { key: 'info', label: '' },


        ],
        op: {
            airflow: '',
            pressure: '',
            airflowunits: 1,
            airflowunits_options: [
                { value: 1, text: 'm³/h' },
                { value: 2, text: 'm³/s' },
                { value: 3, text: 'l/s' },
                { value: 4, text: 'cfm' }
            ],
            pressureunits: 5,
            pressureunits_options: [
                { value: 5, text: 'Pa' },
                { value: 6, text: 'N/m²' },
                { value: 7, text: 'mmwg' },
                { value: 8, text: 'inwg' }
            ],
            pressuretype: 'stat',
            pressuretype_options: [
                { value: 'stat', text: 'static' },
                { value: 'tot', text: 'total' },
            ],
            airflow_deviation: [-20, 20],
            pressure_deviation: [-20, 20],
            maxbda:''
        },
        AcousticDistanceData:[]
    }
};

const state = getDefaultState();

const getters = {

};
const mutations = {
    setProductData(state, payload) {
        state.product_data = payload;
        var productdata = payload;
        //handle success
        state.product_data = productdata;
        state.product_data.description_short = productdata.product_descriptions.length>0?productdata.product_descriptions[0].description_short:'';
        state.product_data.description_long = productdata.product_descriptions.length > 0 ?productdata.product_descriptions[0].description_long:'';
        var price = productdata.product_prices.length>0 ? parseFloat(productdata.product_prices[0].price).toFixed(2):0;
        state.product_data.price = price;
        state.product_data.listprice = price;
        state.product_data.delivery = productdata.product_prices.length > 0 ? productdata.product_prices[0].delivery : '';
        state.accessories = productdata.accessories;
        state.acoustics = productdata.acoustic;


        state.product_data.quantity = 0
        state.product_data.product_media = productdata.product_media
        state.product_data.image = productdata.product_media.filter(item => item.media_type == 'image').map(function (image) { return image.path + image.filename })[0]
        state.product_data.state = productdata.state
        state.product_data.wg = productdata.prodgroup
        /* console.log('in setproductdata::')
        console.log(state.acoustics) */


    },
    setProductDataLVText(state, payload) {
        state.lvtext = payload;
       // console.log(state.lvtext);
    },
    /*
    setAcousticsData(state, payload) {
        //state.acoustics = payload;
        //var acoustics_arr = [];
        //acoustics_arr = Object.values(payload);
        for (var k in payload) { //k-curve
            if (k == 0) { //hier soll Bestpoint Kurve genommen werden
                for (var i = 0; i < payload[k][0].length; i++) { //0- point
                    state.acoustics.push(payload[k][0][i]);
                }
            }

        }
        console.log('in setacousticsdata');
    },
    */
    setCurvesData(state, payload) {
        var curves_arr = [];

        for (var curvegroupkey in payload) {
            console.log('setCurvesData payload')
            console.log(payload)
            if (curvegroupkey == "op" || curvegroupkey == "parabola" || curvegroupkey == "interpolated" || curvegroupkey== "cutpoint") {
                curves_arr.push({
                    name: curvegroupkey,
                    curvegroup: curvegroupkey,
                    points: payload[curvegroupkey]
                })
            }
            else {
                for (var curvekey in payload[curvegroupkey]) {
                    curves_arr.push({
                        name: curvekey,
                        curvegroup: curvegroupkey,
                        points: payload[curvegroupkey][curvekey]
                    })
                }

            }

        }

        state.curves = curves_arr;
    },
    setMediaData(state, payload) {
        state.product_media = payload;

    },
    setAccessories(state, payload) {
        state.accessories = payload;
    },

    setChartpropertiesData(state, payload) {
        state.chartproperties = payload;
    },
    setCalculatedPointData(state, payload) {
        state.calculatedpoint = payload;
    },
    setCalculatedPointPolynomial(state, payload) {
        state.calculatedpoint_polynomial = payload;
    },
    resetState(state) {
        Object.assign(state, getDefaultState())
    },
    updateop(state, payload) {
        console.log('bin in Productdata updateop:');
        console.log(payload);
        state.op = payload;
    },
    updateAcousticDistance(state, payload) {
        state.AcousticDistanceData = payload;
    },
};
//
const actions = {

    InitLoad({ commit }, data) {
        console.log('InitLoad data:');
        console.log(data);
        var op = {}

        op.airflow = data.airflowrate ?? ''
        op.pressure = data.externalpressure ?? ''
        op.airflowunits = data.airflow_unit ?? 1
        op.pressureunits = data.externalpressure_unit ?? 5
        op.pressuretype = data.externalpressuretyp ?? 'stat'
        op.airflow_deviation = data.airflowrate_dev ?? 10
        op.pressure_deviation = data.externalpressure_dev ?? 10
        op.maxdba = data.maxdba?? ''
        op.op_volumeflow = data.airflowrate_is?? ''
        op.op_pressure = data.externalpressure_is?? ''
        op.op_angle=data.wsoll_is??''
        op.op_electricity=data.electricity??''
        op.op_elpower=data.elpower??''
        op.op_rpm=data.rpm??''
        op.op_sfp=data.sfp??''




        commit('updateop', op);
        productdataApi.getProductdata(data)
            .then(responseproduct => {
                console.log('responseproduct:');
                console.log(responseproduct);
                var params = { ref_no: responseproduct.data.productdata[0].ref_no, version: responseproduct.data.productdata[0].version }
                productdataApi.getProductMediadata(params)
                    .then(responsemediadata => {
                        //responseproduct.data.productdata[0].product_media = responsemediadata.data.productmediadata
                        commit('setMediaData', responsemediadata.data.productmediadata);
                    })
                    .catch(function () {
                        console.log('InitLoad getProductMediadata Error');
                    });
                /*
                //ToDo: must move to component (calculated value are in curves point=> need responseproduct.data.curves)
                productdataApi.getProductAcoustics(params)
                    .then(responsacoustics => {
                //        responseproduct.data.productdata[0].acoustics = responsacoustics.data.acoustics
                        commit('setAcousticsData', responsacoustics.data.acoustics);


                    })
                    .catch(function () {
                        console.log('InitLoad getProductresponsAcoustics Error');
                    });
                */
                console.log('responseproduct: ')
                console.log(responseproduct.data.productdata[0])

                commit('setProductData', responseproduct.data.productdata[0]);
                document.title=responseproduct.data.productdata[0].ref_no+'-'+responseproduct.data.productdata[0].version+' | '+responseproduct.data.productdata[0].type
                /*
                commit('setCurvesData', responseproduct.data.curves);
                commit('setChartpropertiesData', responseproduct.data.chartproperties);
                commit('setCalculatedPointData', responseproduct.data.calculatedpoint);
                console.log('InitLoad responseproductdata:');
                console.log(responseproduct.data);*/

            })
            .catch(function (error) {

                if (error.response) {
                    if (error.response.status === 404) {
                        //window.alert(error.message);
                        console.log('Fehler productdataApi.getProductdata');
                        window.alert('Product not available'); //
                       // console.log(error.message);
                        console.log(error.response.statusText) // "Not Found"
                        commit('resetState')

                    }
                }


            });


        /* globalsApi.returnMediaData({ language_id: navigator.language })
            .then(response => {
                console.log('InitLoads returnMediaData response:')
                console.log(response.data)
                commit('setmediaData', response.data);



                productdataApi.getProductdata(data)
                    .then(responseproduct => {
                        //console.log(responseproduct.data.productdata[0]);
                        commit('setProductData', responseproduct.data.productdata[0]);
                        commit('setAcousticsData', responseproduct.data.acoustics);
                        commit('setCurvesData', responseproduct.data.curves);
                        commit('setChartpropertiesData', responseproduct.data.chartproperties);
                        commit('setCalculatedPointData', responseproduct.data.calculatedpoint);

                    })
                    .catch(function () {
                        console.log('Fehler productdataApi.getProductdata');
                    });
            }).catch(error => {
                console.log('InitLoads returnMediaData error');
                console.log(error);
            });
         */

       /*  productdataApi.getProductLVText('6102.txt')
            .then(response => {
                //console.log(response.data);
                commit('setProductDataLVText', response.data);
            })
            .catch(function () {
                console.log('Fehler productdataApi.getProductLVText');
            }); */


    },
    resetState({ commit }) {
        commit('resetState')
    },

};



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

